import mixpanel from "mixpanel-browser";

class MixpanelService {
    initialized = false;

    init() {
        if (this.initialized) return;

        mixpanel.init(process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN || 'dbg', {
            debug: process.env.NODE_ENV !== 'production',
            persistence: 'localStorage',
            persistence_name: 'app_meprism_mixpanel_prod',
            property_blacklist: [],
            cookie_name: 'app_meprism_mp_prod',
            cookie_domain: '.meprism.com',
            secure_cookie: true,
            cross_subdomain_cookie: false,
        });

        this.initialized = true;
    }
}

export const mixpanelService = new MixpanelService();
export { mixpanel };
